<h3 mat-dialog-title >
    <b>Boleta Fundo de Investimento</b> 
</h3>
 
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.cliente_id == null">
     <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
         <mat-label>Cliente</mat-label>
         <input 
             matInput 
             placeholder="Digite o nome ou conta de um cliente" 
             aria-label="Cliente"  
             [formControl]="cliente" 
             name="cliente" 
             required
             [matAutocomplete]="auto">
         <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
             <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                 <span> {{cliente.nome}}</span> |
                 <small>Conta: {{cliente.numero_xp }}</small>
             </mat-option>
         </mat-autocomplete>
         <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
         <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
     </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
        <mat-label>Fundo de Investimento</mat-label>
        <input 
            matInput 
            placeholder="Digite o nome ou CNPJ do Fundo" 
            aria-label="Fundo Investimento"  
            [formControl]="fundo" 
            name="fundo" 
            required
            [matAutocomplete]="auto">
        <mat-autocomplete 
            #auto="matAutocomplete" 
            [displayWith]="displayFnFundo" 
            (optionSelected)='getFundo($event.option.value)'
        >
            <mat-option *ngFor="let fundo of filteredOptionsFundo | async" [value]="fundo">
                <span> {{fundo.nome}}</span> |
                <small>CNPJ: {{fundo.cnpj | mask: '00.000.000/0000-00' }}</small>
            </mat-option>
        </mat-autocomplete>
        <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinnerFundoInvestimento">account_circle</mat-icon>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerFundoInvestimento"></mat-spinner>
    </mat-form-field>
</div>
 
<div fxLayout="row" fxLayoutAlign="space-between">
     <mat-form-field style="width: 100%" floatLabel="always" fxFlex="100" appearance="outline" >
         <mat-label>Quantidade</mat-label>
         <input 
             matInput 
             placeholder="Quantidade" 
             [formControl]="qtd"
             maxlength="10"> 
     </mat-form-field>
</div>
 
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Status</mat-label>
        <mat-select 
            placeholder="Status"
            [(value)]="model.status_id" 
            [formControl]="status_id"
            name="status_id"
            required             
        >
            <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
    </mat-form-field>
</div>
 
<div mat-dialog-content>
     <div fxLayout="row wrap">
         <div fxFlex.gt-sm="100%">
             <p style="text-align: center; color: #030a31;">
                 <b>Qual o valor</b> que deseja <b>{{texto}}</b> ?
             </p>
             <mat-form-field style="width: 100%">                
                 <input 
                     matInput 
                     placeholder="Valor" 
                     [formControl]="valor" 
                     required
                     style="font-size: 30px;"
                     currencyMask 
                     [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'center' }"
                     maxlength="255">
                 <mat-error *ngIf="valor.invalid">{{getErrorValorMessage()}}</mat-error>
             </mat-form-field>
         </div>
    </div>
</div>
 
<div mat-dialog-actions style="text-align: center; margin-top: 20px;">
    <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
    </button>
    <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
    </button>
</div>